import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const PhotosContainer = styled.div`
  width: 90%;
  margin: 0 auto;

  @media only screen and (max-width: 767px) {
    width: 100%;
    height: auto;
  }

  .carousel .slide {
    height: 30rem; 
    overflow: hidden; 
  }

  .carousel .slide > div {
    height: 100%;
    background: black;
  }

  @media only screen and (max-width: 767px) {
    .carousel .slide {
      max-height: 40vh;
    }
  }

  .control-arrow {
    opacity: 1 !important;
    background: rgba(0, 0, 0, 0.5) !important;
    width: 4rem !important;
    height: 4rem !important;
    border-radius: 50% !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    z-index: 10;
    transition: background 0.3s;
  }

  .control-arrow:hover {
    background: rgba(0, 0, 0, 0.8) !important;
  }

  .control-prev:before,
  .control-next:before {
    font-size: 2rem !important;
    color: white !important;
  }

  ${props => props.isModal && css`
      width: 100%;
      .carousel .slide {
      height: 40rem; 
      overflow: hidden; 
    }
  `}
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
`;

const PhotoBanner = ({ bannerImages, isModal }) => {
  // debug
  console.log("Banner images", bannerImages)

  return (
    <PhotosContainer isModal={isModal}>
      <Carousel
        infiniteLoop
        showThumbs={false}
        showStatus={false}
      >
        {bannerImages.map((image, index) => (
          <div key={index}>
            <Img src={image} alt={`banner-${index}`} />
          </div>
        ))}
      </Carousel>
    </PhotosContainer>
  );
};

export default PhotoBanner;
